import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateReleaseEarmarkStatusReduxParams } from '~types/feat/approval';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { EarmarkReleaseRequestStatusEnum } from '~utils/enums';

export default function* watchUpdateReleaseEarmarkStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalUpdateReleaseEarmarkStatusAttempt', handleUpdateReleaseEarmarkStatus, api);
}

function* handleUpdateReleaseEarmarkStatus(api: ApprovalGateway, data: PayloadAction<TUpdateReleaseEarmarkStatusReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        id,
        status,
    } = data.payload;

    const response = yield* call([api, api.updateReleaseEarmark], {
        authToken,
        id,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalUpdateReleaseEarmarkStatusFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const successMessage = status === EarmarkReleaseRequestStatusEnum.Approved
            ? SuccessMessages.ApprovalApproveReleaseEarmarkSuccess
            : status === EarmarkReleaseRequestStatusEnum.Rejected
                ? SuccessMessages.ApprovalRejectReleaseEarmarkSuccess
                : '';

        yield put(combinedActions.approvalSetConfirmUpdateReleaseEarmarkStatusModalIsOpen(false));
        yield put(combinedActions.approvalGetPendingReleaseEarmarkListingAttempt());
        yield put(combinedActions.approvalUpdateReleaseEarmarkStatusSuccess());

        toast.success(successMessage);
    }
}
